import { render, staticRenderFns } from "./ViewCommodity.vue?vue&type=template&id=4cb181d0&scoped=true&"
import script from "./ViewCommodity.vue?vue&type=script&lang=js&"
export * from "./ViewCommodity.vue?vue&type=script&lang=js&"
import style0 from "./ViewCommodity.vue?vue&type=style&index=0&id=4cb181d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb181d0",
  null
  
)

export default component.exports